import { render } from "./tpl-view-list.vue?vue&type=template&id=23bbf23d&scoped=true"
import script from "./tpl-view-list.vue?vue&type=script&lang=js"
export * from "./tpl-view-list.vue?vue&type=script&lang=js"

import "./tpl-view-list.vue?vue&type=style&index=0&id=23bbf23d&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bbf23d"],['__file',"src/views/dragger/template/tpl-view-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23bbf23d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23bbf23d', __exports__)) {
    console.log('reload')
    api.reload('23bbf23d', __exports__)
  }
  
  module.hot.accept("./tpl-view-list.vue?vue&type=template&id=23bbf23d&scoped=true", () => {
    console.log('re-render')
    api.rerender('23bbf23d', render)
  })

}


export default __exports__